import axios from "axios";
import { TTP_API_URL } from "Config";
import { throwCatchedError } from "Utils";

export const saveComment = ({
  token,
  objectType,
  objectId,
  comment,
  organizationId
}) => {
  const requestUrl = `${TTP_API_URL}/media/comment`;

  let formData = new FormData();
  formData.append("access_token", token);
  formData.append(`${objectType.toLowerCase()}`, objectId);
  formData.append("organization", organizationId);
  formData.append("comment", comment);

  return axios.post(requestUrl, formData);
};

export const fetchComments = ({
  token,
  limit,
  objectType,
  objectId,
  organizationId = null
}) => {
  let filter = [
    {
      property: "media.id",
      value: objectId,
      operator: "eq"
    }
  ];
  if (organizationId) {
    filter.push({
      property: "organization.id",
      value: organizationId,
      operator: "eq"
    });
  }
  const sort = [
    {
      property: "createdAt",
      dir: "asc"
    }
  ];

  const fields = ["*"];
  const requestUrl = `${TTP_API_URL}/media/comment`;

  return axios
    .get(requestUrl, {
      params: {
        access_token: token,
        filter: JSON.stringify(filter),
        sort: JSON.stringify(sort),
        fields: fields.join(","),
        limit
      }
    })
    .catch(function(thrown) {
      throwCatchedError(thrown);
    });
};



// WEBPACK FOOTER //
// ./src/api/comment.js